module.exports = __webpack_public_path__ + "static/media/issue1.68bce876.webp";